<!-- Wanted to isolate the video as much as possible so moved it to its own component -->
<template>
  <div>
    <video
      ref="the_video"
      :src="videoUrl"
      width="1024" height="768"
      id="video"
    />
  </div>
</template>

<script>
import logger from '@/logger';
// Using EventBus to create pub/sub between video and store
import EventBus from '@/EventBus';
import { mapState } from 'vuex';

export default {
  name: 'RecordingVideo',
  props: ['videoUrl', 'timestamp'],
  mounted() {
    this.syncPlaybackPosition();
    EventBus.$on('video/pause', this.pauseVideo);
    EventBus.$on('video/play', this.playVideo);
    EventBus.$on('video/seekTo', this.seekTo);
  },
  destroyed() {
    EventBus.$off('video/pause', this.pauseVideo);
    EventBus.$off('video/play', this.playVideo);
    EventBus.$off('video/seekTo', this.seekTo);
  },
  computed: {
    ...mapState({
      events: state => state.recordings.events.data,
    }),
  },
  methods: {
    syncPlaybackPosition() {
      const video = this.$refs.the_video;
      const canPlayCallback = () => {
        logger.log('I am ready to play');

        if (this.timestamp && this.timestamp > 0) {
          logger.log('seeking to', `${this.timestamp}ms`);
          this.seekTo(this.timestamp);
        }
        // dispatch action to commit info about video
        this.$store.dispatch('recordings/videoReady');
        video.removeEventListener('canplay', canPlayCallback);
      };
      // A lot video code relies on the video being in the ready state.
      // This is how we assert the video is ready before kicking off other actions
      video.addEventListener('canplay', canPlayCallback);

      // Update the playbackPosInMS as video plays
      video.addEventListener('timeupdate', () => {
        const currentVideoTime = video.currentTime;
        this.$store.dispatch('recordings/updateVideoTime', { currentVideoTime });
      });

      // Check if video is seeking or seeked
      video.addEventListener('seeked', () => {
        this.$store.dispatch('recordings/seekingComplete');
      });

      video.addEventListener('error', (e) => {
        this.$store.dispatch('recordings/videoError', e);
      }, /* capture from descendents */ true);
    },
    playVideo() {
      this.$refs.the_video.play();
      this.$store.dispatch('recordings/videoPlaying');
    },
    pauseVideo() {
      this.$refs.the_video.pause();
      this.$store.dispatch('recordings/videoPaused');
    },
    seekTo(value) {
      const video = this.$refs.the_video;
      video.currentTime = value / 1000;
      this.$store.dispatch('recordings/updateVideoTime', { currentVideoTime: value / 1000 });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/RecordingVideo.vue